import { useSelector } from "react-redux"
import { useGetPlayersByTournament } from "../../StrikerScreen/hooks/useGetPlayersByTournament"
import { setAssitersPlayerByTournament } from "../redux/actions"

export const useGetAssistersPlayers = ()=>{
    const selectedTournament = useSelector(state => state?.tournaments?.selectedTournament)
    const assisterPlayerByTournament = useSelector(state => state?.assisterPlayer?.assitersByTournament) || []
    const assiterPlayerSort = assisterPlayerByTournament?.sort(function compareFn(a, b) {
            if (a.asistencias < b.asistencias) {
              return 1;
            } else if (a.asistencias > b.asistencias) {
              return -1;
            }
            // a must be equal to b
            return 0;
          }).filter(player => player?.asistencias > 0)

    console.log('assiterPlayerSort', assiterPlayerSort)

    useGetPlayersByTournament( { setUpPlayers: setAssitersPlayerByTournament})

    return{
        selectedTournament,
        assiterPlayerSort
    }
}